/* eslint-disable @typescript-eslint/explicit-function-return-type */
// generated with  npx @svgr/cli src/assets/icons --out-dir src/components/Icons --icon --typescript
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRosatomLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="url(#rosatomLogo_svg__a)"
      d="M13.872 13.689a2.523 2.523 0 0 1-3.746-3.379 2.522 2.522 0 0 1 3.746 3.379"
    />
    <path
      fill="url(#rosatomLogo_svg__b)"
      d="M4.783 2.413A12.038 12.038 0 0 0 .985 7.236c.997.246 3.982 1.218 5.352 4.916.412-.134 1.3-.652 1.916-2.65.826-2.675 2.394-5.248 4.426-6.113-2.027-2.005-4.698-2.477-7.896-.976"
    />
    <path
      fill="url(#rosatomLogo_svg__c)"
      d="M21.242 4.348c0-.001 0-.001 0 0A11.97 11.97 0 0 0 12 0C9.291 0 6.79.898 4.783 2.413c4.44-2.084 7.863-.365 9.959 3.98 3.338.599 5.606-1.062 6.5-2.045"
    />
    <path
      fill="url(#rosatomLogo_svg__d)"
      d="M7.308 23.043a12.033 12.033 0 0 0 6.077.878c-.286-.986-.937-4.058 1.58-7.093-.322-.29-1.214-.8-3.252-.335-2.73.622-5.742.551-7.507-.777-.724 2.757.202 5.307 3.102 7.327"
    />
    <path
      fill="url(#rosatomLogo_svg__e)"
      d="M.753 7.82za11.975 11.975 0 0 0 .856 10.178 11.943 11.943 0 0 0 5.7 5.045c-4.026-2.804-4.248-6.629-1.534-10.616C4.623 9.237 2.05 8.103.753 7.82"
    />
    <path
      fill="url(#rosatomLogo_svg__f)"
      d="M23.91 10.54A12.038 12.038 0 0 0 21.63 4.84c-.711.74-3.045 2.84-6.932 2.177-.09.424-.086 1.452 1.337 2.985 1.903 2.053 3.348 4.697 3.08 6.89 2.75-.753 4.494-2.83 4.794-6.35"
    />
    <path
      fill="url(#rosatomLogo_svg__g)"
      d="M14.005 23.829a11.97 11.97 0 0 0 8.386-5.83 11.942 11.942 0 0 0 1.519-7.458c-.417 4.888-3.616 6.993-8.426 6.636-2.188 2.592-1.883 5.386-1.479 6.652"
    />
    <defs>
      <linearGradient
        id="rosatomLogo_svg__b"
        x1={3.491}
        x2={9.457}
        y1={10.304}
        y2={1.117}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4495D1" />
        <stop offset={1} stopColor="#15256D" />
      </linearGradient>
      <linearGradient
        id="rosatomLogo_svg__c"
        x1={5.872}
        x2={20.694}
        y1={-0.284}
        y2={5.704}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4495D1" />
        <stop offset={1} stopColor="#15256D" />
      </linearGradient>
      <linearGradient
        id="rosatomLogo_svg__d"
        x1={14.786}
        x2={3.847}
        y1={20.219}
        y2={19.646}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4495D1" />
        <stop offset={1} stopColor="#15256D" />
      </linearGradient>
      <linearGradient
        id="rosatomLogo_svg__e"
        x1={4.426}
        x2={2.201}
        y1={23.451}
        y2={7.621}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4495D1" />
        <stop offset={1} stopColor="#15256D" />
      </linearGradient>
      <linearGradient
        id="rosatomLogo_svg__f"
        x1={17.725}
        x2={22.698}
        y1={5.474}
        y2={15.235}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4495D1" />
        <stop offset={1} stopColor="#15256D" />
      </linearGradient>
      <linearGradient
        id="rosatomLogo_svg__g"
        x1={25.704}
        x2={13.107}
        y1={12.831}
        y2={22.672}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4495D1" />
        <stop offset={1} stopColor="#15256D" />
      </linearGradient>
      <radialGradient
        id="rosatomLogo_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(3.54806 0 0 3.54809 11.187 10.59)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4495D1" />
        <stop offset={1} stopColor="#15256D" />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgRosatomLogo;
